
import { ApiURLs } from "../../../constant/ApiUrls";
import { deleteData, fetchData, postData, updateData, uploadImage } from "../../../services/api";
import { hideAddSettingsModal } from "./settingsModalDispatcher";

  

  export const addSettingsRequest = (data, navigate) => {
    return async (dispatch) => {
      dispatch({"type":"ADD_SETTINGS_REQUEST"});
      try {


        if (data.image) {
          var uploadedImage = await uploadImage(
            ApiURLs.UPLOAD_IMAGE, "image",
            data.image,
            "settings"
          );
          console.log(`upload image function response ${JSON.stringify(uploadedImage)}`)
          data.value = uploadedImage.data.file.path
        }



        var settingsResponse = (data.id)? await updateData(data, `${ApiURLs.SETTINGS}/${data.id}`):await postData(data, ApiURLs.SETTINGS);
        if (settingsResponse.status === 1) {
          dispatch({"type":"ADD_SETTINGS_SUCCESS"});
          dispatch(hideAddSettingsModal());
          dispatch(settingsLisitingRequest());
        } else {
          dispatch({"type":"ADD_SETTINGS_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"ADD_SETTINGS_FAILED"});
  
      }
    };
  };




  export const settingsLisitingRequest = () => {

    return async (dispatch) => {

      const url = `${ApiURLs.SETTINGS}`;
  
      // wait untill the data not received so getData function take data and url part
      dispatch({"type":"GET_SETTINGS_REQUEST"});
      try {
        var settingsData = await fetchData(url);
        console.log(`response when we try to get settings  ${JSON.stringify(settingsData)}`)
        if (settingsData.status === 1) {
          dispatch({"type":"GET_SETTINGS_REQUEST_SUCCESS", "payload":settingsData.data.result});
        
        } else {
          dispatch({"type":"GET_SETTINGS_REQUEST_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"GET_SETTINGS_REQUEST_FAILED"});
        console.log(`error while try to get settings  ${error}`)
      }
    }
  };


    export const deleteSettings = (id) => {
      return async (dispatch) => {
    
        // dispatch();
        dispatch({"type":"DELETE_SETTINGS_REQUEST"});
        try {
    
  
          var settingsResponse = await deleteData(`${ApiURLs.SETTINGS}/${id}`);
          if (settingsResponse.status === 1) {
            dispatch({"type":"ADD_SETTINGS_SUCCESS"});
            dispatch(settingsLisitingRequest());
          } else {
            dispatch({"type":"ADD_SETTINGS_FAILED"});
          }
        } catch (error) {
          dispatch({"type":"ADD_SETTINGS_FAILED"});
    
        }
      };
    };
  

  